/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import * as types from '../constants';

const INITSTATE = {
    preferences: null,
    account_id: null,
    loaded: false,
};

export default function tripPreferencesReducers(state = INITSTATE, action) {
    switch (action.type) {
        case types.PREFERENCES_UPDATE_SUCCESS:
            return {
                ...state,
                preferences:
                    action.payload.trip_preferences ?? action.payload.preferences,
                account_id: action.payload.account_id,
                loaded: true,
            };

        case types.PREFERENCES_UPDATE_FAILED:
            return { ...state, loaded: true };

        default:
            return state;
    }
}
